import React, { useState, useContext, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "../../Common/Button/Button";
import "./Settings.css";
import Badge from "@mui/material/Badge";
import { ReactComponent as UploadIcon } from "../../Assets/Images/profile-edit-icon.svg";
import PlaceholderIcon from "../../Assets/Images/image-placeholder-loader.png";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import ContentDialog from "../../Common/Content-Dialog/ContentDialog";
import BannerUploadIcon from "../../Assets/Images/banner-upload-icon.png";
import { handleLogoutCommon } from "../../Common/Common-Function/CommonFunctions";
import { useFormik } from "formik";
import * as Yup from "yup";
import TextField from "../../Common/Textfield/Textfield";
import ChangePlanIcon from "../../Assets/Images/change-plan-icon.png";
import PhoneNumberInput from "../../Common/PhoneNumberInput/PhoneNumberInput";
import { DynamicContext } from "../../Context/DynamicContext";
import DeleteIcon from '@mui/icons-material/Delete';
import { post, put, deleteRequest } from "../../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  CHANGE_PASSWORD,
  UPLOAD_USER_IMAGE,
  GET_RECRUITER_BY_ID,
  USERS_UPDATE,
  USERS_REMOVE_IMAGE,
} from "../../helper/url_helper";
import { get } from "../../helper/Api_helper";
import { useNavigate } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import TimezoneSelector from "../../Common/Calendar-Scheduler/TimezoneSelector";
import "moment-timezone";
import CropImage, { getCroppedImg } from "../../Common/Crop-Image/CropImage";

function ProfileDetails() {
  const navigate = useNavigate();

  const { userDetails, setUserDetails, userTimezone, setUserTimezone } =
    useContext(DynamicContext);
  const [previewImage, setPreviewImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPersonalDetailsEditing, setIsPersonalDetailsEditing] =
    useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [fetchUserDetails, setFetchUserDetails] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  // const [avatarImage, setAvatarImage] = useState(fetchUserDetails?.profile_image_key || null);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchedUser, setFetchedUser] = useState(null);
  const [avatarImage, setAvatarImage] = useState(
    fetchedUser?.profile_image_key || null
  );
  const [isTimezoneDialogOpen, setIsTimezoneDialogOpen] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(userTimezone);
  const [isCropMode, setIsCropMode] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  useEffect(() => {
    setSelectedTimezone(userTimezone);
  }, [userTimezone]);

  const handleTimezoneChange = (newTimezone) => {
    if (isTimezoneDialogOpen) {
      setSelectedTimezone(newTimezone);
    }
  };

  const handleOpenTimezoneDialog = () => {
    setSelectedTimezone(userTimezone);
    setIsTimezoneDialogOpen(true);
  };

  const handleCloseTimezoneDialog = () => {
    setIsTimezoneDialogOpen(false);
    setSelectedTimezone(userTimezone);
  };

  const handleApplyTimezone = async () => {
    try {
      await put(VYLABS_BASE_URL, USERS_UPDATE, {
        timezone: selectedTimezone,
      });
      setUserTimezone(selectedTimezone);
      setUserDetails((prev) => ({
        ...prev,
        timezone: selectedTimezone,
      }));
      setIsTimezoneDialogOpen(false);
      Toast("success", "Timezone updated successfully");
    } catch (error) {
      console.error("ApplyTimezone error", error);
      Toast("error", "Failed to update timezone");
    }
  };

  const handleDeleteImage = async () => {
    try {     
      await deleteRequest(VYLABS_BASE_URL, `${USERS_REMOVE_IMAGE}?id=${userDetails?.id}`);
      setAvatarImage(null);

      setUserDetails((prev) => ({
        ...prev,
        profile_image_key: null,
      }));
      Toast("success", "Profile image removed successfully");
      handleCloseMenu();
    } catch (error) {
      console.error("Error deleting profile image:", error);
      Toast("error", "Failed to remove profile image");
    }
  }

  // const validationSchema = Yup.object({
  //   fullName: Yup.string()
  //     .min(3, "Full Name must be at least 3 characters.")
  //     .max(50, "Full Name must be at most 50 characters.")
  //     .required("Full Name is required."),
  //   phoneNumber: Yup.string()
  //     .min(10, "Must be at least 10 digits.")
  //     .required("Phone Number is required."),
  //   timeZone: Yup.string().required("Time Zone is required."),
  //   companyName: Yup.string()
  //     .min(3, "Company Name must be at least 3 characters.")
  //     .max(50, "Company Name must be at most 50 characters.")
  //     .required("Company Name is required."),
  //   addressLine1: Yup.string()
  //     .min(5, "Address Line 1 must be at least 5 characters.")
  //     .required("Address Line 1 is required."),
  //   addressLine2: Yup.string(),
  //   city: Yup.string()
  //     .min(2, "City must be at least 2 characters.")
  //     .required("City is required."),
  //   state: Yup.string()
  //     .min(2, "State must be at least 2 characters.")
  //     .required("State is required."),
  //   country: Yup.string()
  //     .min(2, "Country must be at least 2 characters.")
  //     .required("Country is required."),
  //   pincode: Yup.string()
  //     .matches(/^\d{5,10}$/, "Invalid Pincode format.")
  //     .required("Pincode is required."),
  // });
  const passwordFormik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old Password is required."),
      newPassword: Yup.string()
        .min(8, "New Password must be at least 8 characters.")
        .required("New Password is required.")
        .test(
          "not-same-as-old",
          "New password cannot be the same as the old password.",
          function (value) {
            return value !== this.parent.oldPassword;
          }
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match.")
        .required("Confirm Password is required."),
    }),
  });
  const personalDetailsFormik = useFormik({
    initialValues: {
      fullName: userDetails?.first_name + " " + userDetails?.last_name || "",
      firstName: userDetails?.first_name || "",
      lastName: userDetails?.last_name || "",
      email: userDetails?.email || "",
      phoneNumber: userDetails?.phone || "",
      timeZone: "IST (Indian Standard Time)",
    },
  });

  const fetchUser = React.useCallback(async () => {
    if (!userDetails?.id) {
      setIsLoading(false);
      return;
    }
    try {
      setIsLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_RECRUITER_BY_ID}?id=${userDetails?.id}`
      );
      if (response?.user) {
        setFetchedUser(response.user);
        if (response.user.profile_image_key) {
          setAvatarImage(response.user.profile_image_key);
        }
      } else {
        console.error("failed to fetch user details");
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setIsLoading(false);
    }
  }, [userDetails?.id]);
  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const handlePerseronalDetailsSubmit = async () => {
    const { firstName, lastName, phoneNumber } = personalDetailsFormik.values;
    const missing = {
      firstName: !firstName?.trim(),
      lastName: !lastName?.trim(),
      phoneNumber: !phoneNumber?.trim(),
    };
    if (missing.firstName || missing.lastName || missing.phoneNumber) {
      await personalDetailsFormik.setTouched(
        { firstName: true, lastName: true, phoneNumber: true },
        true
      );
      Toast("error", "Please fill all the required fields correctly");
      return;
    }
    await personalDetailsFormik.setTouched(
      { firstName: true, lastName: true, phoneNumber: true },
      true
    );
    const errors = await personalDetailsFormik.validateForm();
    if (Object.keys(errors).length === 0) {
      try {
        const {
          firstName = "",
          lastName = "",
          phoneNumber = "",
        } = personalDetailsFormik.values;
        const phoneWithPlus = phoneNumber.startsWith("+")
          ? phoneNumber
          : `+${phoneNumber}`;
        const payload = {
          first_name: firstName || "",
          last_name: lastName || "",
          phone: phoneWithPlus || "",
        };
        await put(VYLABS_BASE_URL, USERS_UPDATE, payload);
        setUserDetails((prev) => ({
          ...prev,
          first_name: payload.first_name,
          last_name: payload.last_name,
          phone: payload.phone,
        }));
        await fetchUser();
        Toast("success", "Profile details saved successfully");
        setIsPersonalDetailsEditing(false);
      } catch (e) {
        Toast("error", "Failed to save profile details");
      }
    } else {
      const firstError = Object.values(errors)[0];
      if (firstError) {
        Toast("error", firstError);
      } else {
        Toast("error", "Please fill all the fields correctly");
      }
    }
  };

  const handleChangePassword = async () => {
    await passwordFormik.setTouched({
      oldPassword: true,
      newPassword: true,
      confirmPassword: true,
    });
    await passwordFormik.validateForm();

    if (passwordFormik.isValid && passwordFormik.dirty) {
      try {
        const response = await post(VYLABS_BASE_URL, CHANGE_PASSWORD, {
          newPassword: passwordFormik.values.newPassword,
          oldPassword: passwordFormik.values.oldPassword,
        });
        if (response === "ok") {
          Toast("success", "Password changed successfully");
          passwordFormik.resetForm();
          handleLogoutCommon({
            setUserDetails,
            afterLogoutNavigate: () => {
              navigate("/login");
            },
          });
        } else {
          Toast("error", "Failed to change password");
        }
      } catch (error) {
        Toast("error", "An error occurred while changing password");
      }
    } else {
      const errors = Object.values(passwordFormik.errors);
      if (errors.length > 0) {
        Toast("error", errors[0]);
      } else {
        Toast("error", "Please fill all the fields correctly");
      }
    }
  };

  const handleShowChangePasswordPage = () => {
    setShowChangePassword(true);
  };
  const handleCloseChangePasswordPage = () => {
    setShowChangePassword(false);
    passwordFormik.resetForm();
  };
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = () => {
    setPreviewImage(null);
    setIsModalOpen(true);
    handleCloseMenu();
  };

  const handleUploadImage = async () => {
    let fileToUpload = previewImage;

    if (fileToUpload instanceof File && croppedAreaPixels) {
      try {
        const imageSrc = URL.createObjectURL(fileToUpload);
        const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
        fileToUpload = new File([croppedBlob], previewImage.name || "profile.jpg", {
          type: previewImage.type,
        });
        URL.revokeObjectURL(imageSrc);
      } catch (error) {
        console.error("Crop error:", error);
        Toast("error", "Failed to crop image");
        return;
      }
    }

    if (fileToUpload instanceof File) {
      const formData = new FormData();
      formData.append("file", fileToUpload);
      formData.append("user_id", userDetails?.id);
      post(VYLABS_BASE_URL, UPLOAD_USER_IMAGE, formData)
        .then((response) => {
          const newImageUrl = response.url;
          setAvatarImage(newImageUrl);
          setIsModalOpen(false);
          setIsCropMode(false);
          setPreviewImage(null);
          setUserDetails((prev) => ({
            ...prev,
            profile_image_key: newImageUrl,
          }));
          Toast("success", "User Image uploaded successfully");
        })
        .catch((error) => {
          Toast("error", "Failed to upload image");
          console.error("Upload error:", error);
        });
    } else {
      Toast("warning", "Please select a valid image file to upload");
    }
  };

  const handleFileUpload = (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      Toast(
        "warning",
        "Invalid file type. Only JPG, JPEG, or PNG are allowed."
      );
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      Toast("warning", "Please upload an image less than 5MB.");
      return;
    }
    setPreviewImage(file);
    setIsCropMode(true);
  };

  const onCropComplete = React.useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleSelectFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFileUpload(file);
    } else {
      Toast("warning", "No file selected. Please try again.");
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };
  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      personalDetailsFormik.setFieldValue("phoneNumber", phone);
      personalDetailsFormik.setFieldTouched("phoneNumber", true, false);
      personalDetailsFormik.validateField("phoneNumber");
    },
    [personalDetailsFormik]
  );

  const handleProfileDetailsCancel = () => {
    personalDetailsFormik.resetForm();
    setIsPersonalDetailsEditing(false);
  };
  const handleDownloadImage = () => {
    if (avatarImage) {
      window.open(avatarImage, "_blank");
    } else {
      Toast("warning", "No image available to download");
    }
  };
  return (
    <>
      {showChangePassword ? (
        <div className="change-password-container">
          <div className="change-password-title-container">
            <h2 className="change-password-title">Change Password</h2>
          </div>
          <div className="password-field-container">
            <TextField
              type="password"
              placeholder="Enter your old password"
              label="Old Password"
              labelStyle={{ fontWeight: 500 }}
              name="oldPassword"
              value={passwordFormik.values.oldPassword}
              onChange={passwordFormik.handleChange}
              onBlur={passwordFormik.handleBlur}
              error={
                passwordFormik.touched.oldPassword &&
                passwordFormik.errors.oldPassword
              }
              errorMessage={passwordFormik.errors.oldPassword}
              showPasswordToggle={true}
              required={true}
            />
          </div>
          <div className="passwords-field-container">
            <TextField
              type="password"
              placeholder="Enter your new password"
              label="New Password"
              labelStyle={{ fontWeight: 500 }}
              name="newPassword"
              value={passwordFormik.values.newPassword}
              onChange={passwordFormik.handleChange}
              onBlur={passwordFormik.handleBlur}
              error={
                passwordFormik.touched.newPassword &&
                passwordFormik.errors.newPassword
              }
              errorMessage={passwordFormik.errors.newPassword}
              showPasswordToggle={true}
              required={true}
            />
            <TextField
              type="password"
              placeholder="Re-enter your new password"
              label="Confirm New Password"
              labelStyle={{ fontWeight: 500 }}
              name="confirmPassword"
              value={passwordFormik.values.confirmPassword}
              onChange={passwordFormik.handleChange}
              onBlur={passwordFormik.handleBlur}
              error={
                passwordFormik.touched.confirmPassword &&
                passwordFormik.errors.confirmPassword
              }
              errorMessage={passwordFormik.errors.confirmPassword}
              showPasswordToggle={true}
              required={true}
            />
          </div>
          <div className="change-password-button-container">
            <Button
              label="Cancel"
              isCancel={true}
              event={handleCloseChangePasswordPage}
            />
            <Button label="Update Password" event={handleChangePassword} />
          </div>
        </div>
      ) : (
        <div className="profile-details-container">
          <div className="settings-title-container">
            <h2>Profile Details</h2>
            <p>Manage your personal information and account settings.</p>
          </div>
          <div className="profile-main-details-container">
            <div className="avatar-container">
              <Badge
                overlap="circular"
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                style={{ cursor: "pointer" }}
                badgeContent={<UploadIcon className="edit-icon" />}
                onClick={handleOpenMenu}
              >
                <Avatar
                  alt={fetchUserDetails?.name}
                  src={
                    isLoading ? PlaceholderIcon : avatarImage || PlaceholderIcon
                  }
                  sx={{ width: 80, height: 80 }}
                />
              </Badge>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                PaperProps={{
                  sx: {
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  },
                }}
              >
                <MenuItem
                  onClick={handleOpenModal}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#e0e0e0",
                    },
                  }}
                >
                  <ListItemIcon>
                    <EditIcon fontSize="small" />
                  </ListItemIcon>
                  {avatarImage ? "Edit Image" : "Upload Image"}
                </MenuItem>
                {avatarImage && (
                  <MenuItem
                    onClick={handleDownloadImage}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    <ListItemIcon>
                      <DownloadIcon fontSize="small" />
                    </ListItemIcon>
                    Download Image
                  </MenuItem>
                )}
                {avatarImage && (
                  <MenuItem
                    onClick={handleDeleteImage}
                    sx={{
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    Remove Image
                  </MenuItem>
                )}
              </Menu>
              <div className="name-details">
                <h3 className="user-name">
                  {userDetails?.first_name} {userDetails?.last_name}
                </h3>
                <span className="user-email">{userDetails?.email}</span>
              </div>
            </div>
            <div>
              <Button
                label="Change Password"
                event={handleShowChangePasswordPage}
              />
            </div>
          </div>

          <div className="personal-details-container">
            <div className="personal-details-outer-container">
              <div className="heading-container">
                <h3>Personal Details</h3>
                {isPersonalDetailsEditing ? (
                  <div className="header-button-container">
                    <Button
                      label="Cancel"
                      isCancel={true}
                      event={handleProfileDetailsCancel}
                    />
                    <Button
                      label="Save"
                      event={handlePerseronalDetailsSubmit}
                    />
                  </div>
                ) : (
                  <Button
                    label="Edit"
                    iconSrc={ChangePlanIcon}
                    backgroundColor="var(--body__background)"
                    color="#6860EE"
                    border="1px solid var(--border__color)"
                    style={{ padding: "8px 12px" }}
                    iconWidth="15px"
                    event={() => setIsPersonalDetailsEditing(true)}
                  />
                )}
              </div>
              <div
                className={`personal-details-inner-container ${
                  isPersonalDetailsEditing ? "edit-mode" : ""
                }`}
              >
                {isPersonalDetailsEditing ? (
                  <>
                    <div>
                      <label className="personal-details-label">
                        First Name
                      </label>
                      <TextField
                        value={personalDetailsFormik.values.firstName}
                        onChange={personalDetailsFormik.handleChange}
                        name="firstName"
                        error={
                          personalDetailsFormik.touched.firstName &&
                          personalDetailsFormik.errors.firstName
                        }
                        errorMessage={personalDetailsFormik.errors.firstName}
                      />
                    </div>
                    <div>
                      <label className="personal-details-label">
                        Last Name
                      </label>
                      <TextField
                        value={personalDetailsFormik.values.lastName}
                        onChange={personalDetailsFormik.handleChange}
                        name="lastName"
                        error={
                          personalDetailsFormik.touched.lastName &&
                          personalDetailsFormik.errors.lastName
                        }
                        errorMessage={personalDetailsFormik.errors.lastName}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <label className="personal-details-label">
                        Full Name
                      </label>
                      <h4>
                        {personalDetailsFormik.values.firstName}{" "}
                        {personalDetailsFormik.values.lastName}
                      </h4>
                    </div>
                    <div>
                      <label className="personal-details-label">Email</label>
                      <h4>{personalDetailsFormik.values.email}</h4>
                    </div>
                  </>
                )}

                <div
                  className={
                    isPersonalDetailsEditing ? "grid-column-span-2" : ""
                  }
                >
                  <label className="personal-details-label">Phone Number</label>
                  {isPersonalDetailsEditing ? (
                    <PhoneNumberInput
                      value={personalDetailsFormik.values.phoneNumber}
                      onChange={handlePhoneInputChange}
                      onBlur={personalDetailsFormik.handleBlur}
                      error={personalDetailsFormik.errors.phoneNumber}
                      touched={personalDetailsFormik.touched.phoneNumber}
                      placeholder="Phone Number"
                      width="100%"
                      height="45px"
                      countryListWidth="335px"
                      phoneContainerStyle={{ marginTop: "17px" }}
                      required={true}
                    />
                  ) : (
                    <h4>{personalDetailsFormik.values.phoneNumber}</h4>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="personal-details-container">
            <div className="heading-container">
              <h3>Time Zone Selector</h3>
              <Button
                label="Change Time Zone"
                iconSrc={ChangePlanIcon}
                backgroundColor="var(--body__background)"
                color="#6860EE"
                border="1px solid var(--border__color)"
                style={{ padding: "8px 12px" }}
                iconWidth="15px"
                event={handleOpenTimezoneDialog}
              />
            </div>
            <div className="current-timezone-display">
              <label className="personal-details-label">
                Current Time Zone
              </label>
              <h4>{userTimezone || "Not set"}</h4>
            </div>
          </div>
        </div>
      )}

      <ContentDialog
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onCloseIconClose={() => setIsModalOpen(false)}
        submitButtonLabel="Upload"
        cancelButtonLabel={"Cancel"}
        showActionButton={!!previewImage}
        event={handleUploadImage}
        contentWidth="40vw"
        overflowY={true}
        contentHeight="60vh"
        title={
          previewImage
            ? "User Profile Image Preview"
            : "Upload User Profile Image"
        }
      >
        <div>
          {previewImage ? (
            <>
              <div className="preview-container">
                <div style={{width: "200px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px"}}>
                  <CropImage 
                    image={previewImage}
                    onCropComplete={onCropComplete}
                  /> 
                </div>
              </div>
              <div className="info-container">
                <span className="info-span">
                  Save your user profile image by clicking "Upload" below.
                </span>
              </div>
            </>
          ) : (
            <>
              <div
                className="profile-image-container"
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <img
                  src={BannerUploadIcon}
                  alt="BannerUploadIcon"
                  className="banner-upload-icon"
                />
                <span className="upload-text">
                  Drag and drop images to upload
                </span>
                <div className="upload-button-container">
                  <label htmlFor="file-input-candidate">
                    <Button
                      label="Select files"
                      backgroundColor="#fff"
                      color="#000"
                      border="1px solid #ccc"
                      event={() =>
                        document.getElementById("file-input-candidate").click()
                      }
                    />
                  </label>
                  <input
                    id="file-input-candidate"
                    type="file"
                    accept="image/jpeg, image/png, image/gif"
                    style={{ display: "none" }}
                    onChange={(e) => handleSelectFile(e)}
                  />
                </div>
              </div>
              <div className="info-container">
                <span className="info-span">
                  JPG,JPEG,PNG Files are Allowed, Max Size 5MB.
                </span>
              </div>
            </>
          )}
        </div>
      </ContentDialog>
      <ContentDialog
        isOpen={isTimezoneDialogOpen}
        onClose={handleCloseTimezoneDialog}
        onCloseIconClose={handleCloseTimezoneDialog}
        submitButtonLabel="Apply"
        cancelButtonLabel="Cancel"
        event={handleApplyTimezone}
        contentWidth="40vw"
        overflowY={true}
        // contentHeight="50vh"
        title="Change Time Zone"
      >
        <div className="timezone-dialog-content">
          <div className="current-timezone-info">
            <p>
              <strong>Current Time Zone:</strong> {userTimezone || "Not set"}
            </p>
          </div>
          <div className="timezone-selector-container">
            <TimezoneSelector
              selectedTimezone={selectedTimezone}
              onTimezoneChange={handleTimezoneChange}
            />
          </div>
          <div className="timezone-note">
            <p>
              Note: This will update your timezone preference across the
              application.
            </p>
          </div>
        </div>
      </ContentDialog>
    </>
  );
}

export default ProfileDetails;
